import { Divider, Button } from "antd";
import Loader from "Components/Loader";
import { useBranchesHelper } from "Pages/User/BranchManagement/useBranchesHelper";
import React from "react";

type Props = { payload: any; setPayload: any };

const BranchSelection = ({ payload, setPayload }: Props) => {
  const { data, isPending } = useBranchesHelper();

  const handleReset = () => {
    setPayload({ ...payload, branchId: "" });
  };

  const selectedBranch = data?.data?.docs.find(
    (branch) => branch.id === payload.branchId
  );

  return (
    <div>
      {isPending && <Loader />}
      {!isPending && data?.data?.docs ? (
        <div className="bg-[#dadada50] p-2">
          {payload?.branchId !== "" ? (
            <div className="flex justify-between items-center mb-3">
              <h3>Selected Branch</h3>
              <Button onClick={handleReset}>Reset Selection</Button>
            </div>
          ) : (
            <div className="flex mb-3 gap-[30px] font-bold">
              <div className="w-3/12">Name</div>
              <div className="w-9/12">Address</div>
            </div>
          )}
          <Divider />
          {selectedBranch && (
            <div className="mb-3">
              <div className="flex text-sm gap-[40px]">
                <div className="w-3/12">{selectedBranch.name}</div>
                <div className="w-9/12">
                  {selectedBranch.address === ""
                    ? "N/A"
                    : selectedBranch.address}
                </div>
              </div>
              <Divider />
            </div>
          )}
          <div className="h-[250px] overflow-y-scroll">
            {data?.data?.docs.map(({ name, address, code, id }) => (
              <div
                key={code}
                className={`mb-3 cursor-pointer ${
                  payload.branchId === id ? "bg-gray-200" : ""
                }`}
                onClick={() => setPayload({ ...payload, branchId: id })}
              >
                <div className="flex text-sm gap-[40px]">
                  <div className="w-3/12">{name}</div>
                  <div className="w-9/12 ">
                    {address === "" ? "N/A" : address}
                  </div>
                </div>
              </div>
            ))}
            <Divider />
          </div>
        </div>
      ) : (
        <div className="mt-3">
          <h3>No branches available</h3>
        </div>
      )}
    </div>
  );
};

export default BranchSelection;
